import variables from "../../../_constants/variables";
import localOrSessionStore from "../../../_helpers/localOrSessionStore";
import ResourceUserView from "./resourcce.user.view";
import ResourceAdminView from "./resource.admin.view";
import "./resources.scss"

const Resources = () =>{
    const storage = localOrSessionStore({key: variables.REMEMBER});
    const userType = storage.getItem(variables.USER_TYPE);


    return (userType==='MASTER'?<ResourceAdminView/>:<ResourceUserView/>)
}

export default Resources;
